if (!customElements.get('cl2-market-hero-a')) {
  customElements.define('cl2-market-hero-a', class extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 768px)');
      this.tabs = Array.from(this.querySelectorAll('[data-mh-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-mh-panel]'));
      this.onMq = () => this.render();
      this.onClick = (e) => {
        const t = e.target.closest('[data-mh-tab]');
        if (t && this.contains(t)) { this.select(this.tabs.indexOf(t)); return; }
        const card = e.target.closest('[data-mh-panel]');
        if (card && this.contains(card) && this.mq.matches) this.select(this.panels.indexOf(card));
      };
      this.onKey = (e) => {
        const t = e.target.closest('[data-mh-tab]'); if (!t) return;
        const i = this.tabs.indexOf(t), L = this.tabs.length;
        const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: L - 1 };
        if (!(e.key in map)) return;
        e.preventDefault();
        const n = (map[e.key] + L) % L;
        this.select(n); this.tabs[n].focus();
      };
      this.onBlock = (e) => {
        const i = this.panels.findIndex((p) => p.dataset.blockId === e.detail.blockId);
        if (i > -1) this.select(i);
      };
      this.mq.addEventListener('change', this.onMq);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onBlock);
      this.active = Math.max(0, this.panels.findIndex((p) => p.classList.contains('is-active')));
      this.select(this.active);
    }
    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.onMq);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onBlock);
      this.querySelectorAll('[data-mh-media] > video').forEach((v) => { v.pause(); v.remove(); });
    }
    select(i) {
      if (i < 0 || !this.panels[i]) return;
      const prev = this.panels[this.active]?.querySelector('[data-mh-media] > video');
      if (i !== this.active) prev?.pause();
      this.active = i;
      this.tabs.forEach((t, n) => { t.setAttribute('aria-selected', String(n === i)); t.tabIndex = n === i ? 0 : -1; });
      this.panels.forEach((p, n) => { p.classList.toggle('is-active', n === i); p.setAttribute('aria-hidden', String(n !== i)); });
      this.render();
    }
    // Every card owns its own media. Desktop mounts all cards (active plays, rest paused on a frame);
    // mobile mounts only the active card's video.
    render() {
      const device = this.mq.matches ? 'desktop' : 'mobile';
      this.panels.forEach((panel, n) => {
        const host = panel.querySelector('[data-mh-media]'); if (!host) return;
        const isActive = n === this.active;
        let video = host.querySelector(':scope > video');
        if (!isActive && device === 'mobile') { if (video) { video.pause(); video.remove(); } video = null; }
        else if (!video) {
          const tpl = host.querySelector('template[data-mh-video]');
          video = tpl?.content.querySelector('video')?.cloneNode(true) || null;
          if (video) {
            video.muted = true; video.playsInline = true; video.controls = false; video.removeAttribute('controls'); video.removeAttribute('autoplay');
            // Without a poster, seek slightly so a paused card shows a real frame instead of black.
            if (!video.getAttribute('poster')) video.addEventListener('loadedmetadata', () => { if (video.paused && video.currentTime === 0) video.currentTime = 0.1; }, { once: true });
            host.append(video);
          }
        }
        const still = host.querySelector('picture, .cl2-mh__placeholder');
        if (still) still.hidden = Boolean(video);
        if (!video) return;
        if (isActive) video.play().catch(() => {}); else video.pause();
      });
    }
  });
}
